import pack from '../../package.json'

import logoBoanota from '../assets/img/logo-boanota.svg'
import logoTentoscap from '../assets/img/logo-tentoscap.svg'
import logoIvtGrade from '../assets/img/logo-ivtgrade.svg'
import logoIndrema from '../assets/img/logo-indrema.png'

export const VERSION = pack.version
export const ENV: string = process.env.REACT_APP_ENV ?? 'development'
export const STAGE: string = (process.env.REACT_APP_STAGE ?? '').toLowerCase()
export const SCOPE = process.env.REACT_APP_SCOPE || ''
export const SCOPE_GROUP = process.env.REACT_APP_SCOPE_GROUP || 'boanota_front_smart_assistant'

console.log(`v${VERSION} - ${ENV}`)

//  AWS COGNITO ENV
export const AWS_COGNITO_REGION = process.env.REACT_APP_AWS_COGNITO_REGION
export const AWS_USER_POOLS_ID = process.env.REACT_APP_AWS_USER_POOLS_ID
export const AWS_USER_POOLS_WEB_CLIENT_ID = process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID
export const AWS_COGNITO_AUTH_DOMAIN = process.env.REACT_APP_AWS_COGNITO_AUTH_DOMAIN || ''
export const AWS_COGNITO_SHARED_DOMAIN = process.env.REACT_APP_SHARED_DOMAIN || ''

// AWS S3 ENV
export const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID || ''
export const AWS_IDENTITY_POOL_REGION = process.env.REACT_APP_AWS_IDENTITY_POOL_REGION || 'us-east-1'

// GOOGLE MAPS API KEY
export const GOOGLE_AUTHORIZATION_KEY = process.env.REACT_APP_GOOGLE_AUTHORIZATION_KEY || ''

const commonEnvs: { [key: string]: string } = {}

const configs: { [envKey: string]: { [key: string]: string } } = {
  prod: {
    GOOGLE_MAPS_BASE_URL:
    'https://760o4hdpji.execute-api.us-east-1.amazonaws.com/Prod',
    API_BASE_URL: ''
  },
  staging: {
    GOOGLE_MAPS_BASE_URL:
      'https://gkpckl89b9.execute-api.us-east-1.amazonaws.com/Staging',
    API_BASE_URL: 'https://n0oape9ey7.execute-api.us-east-1.amazonaws.com/Staging'
  },
  dev: {
    GOOGLE_MAPS_BASE_URL:
    'https://34b29j11ji.execute-api.us-east-1.amazonaws.com/Dev',
    API_BASE_URL: 'https://05pba1keji.execute-api.us-east-1.amazonaws.com/Dev'
  }
}

const currentEnvs = { ...commonEnvs, ...configs[STAGE] }

export const { GOOGLE_MAPS_BASE_URL, API_BASE_URL } = currentEnvs

export const HEAD_TITLE = process.env.REACT_APP_HEAD_TITLE || ''
export const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR || ''
export const SECONDARY_COLOR = process.env.REACT_APP_SECONDARY_COLOR || ''
export const LIST_BACKGROUND_COLOR = process.env.REACT_APP_LIST_BACKGROUND_COLOR || ''
export const LIST_COLOR = process.env.REACT_APP_LIST_COLOR || ''

const resolveLogo = (scope: string) => {
  switch (scope.toLowerCase()) {
    case 'ftx':
      return logoBoanota
    case 'tentoscap':
      return logoTentoscap
    case 'ivtgrade':
      return logoIvtGrade
    default:
      return logoIndrema
  }
}

export const LOGO = resolveLogo(SCOPE)

const verifyEnv = () => {
  const envs = {
    VERSION,
    ENV,
    AWS_COGNITO_REGION,
    AWS_USER_POOLS_ID,
    AWS_USER_POOLS_WEB_CLIENT_ID,
    AWS_IDENTITY_POOL_ID,
    AWS_IDENTITY_POOL_REGION,
    AWS_COGNITO_AUTH_DOMAIN,
    AWS_COGNITO_SHARED_DOMAIN,
    GOOGLE_AUTHORIZATION_KEY,
    SCOPE,
    STAGE
  }

  Object.entries(envs).forEach(([name, value]) => {
    if ([undefined, null, ''].includes(value)) {
      throw new Error(`${name} is not defined, current value is ${value}`)
    }
  })
}

verifyEnv()
